export class CancelarServicio {
    estado: Number;
    idConductor: string;
    idMotivoCancelacion: Number;
    idServicio: Number;
    motivoCancelacion: string;
    notificarCliente: boolean;
    notificarConductor: boolean;
    Modo_Reserva: number;
    NombrePagina:string;

    constructor() {

    }
}
